module.exports = __webpack_public_path__ + "img/call-me-emperor.5989d5c.jpg";